import { ContestSource } from '@betterpool/api-types/contests-service';

const EO_SOURCES: string[] = [ContestSource.RYP, ContestSource.OFP];

export const getIsEOContest = (source?: string): boolean =>
  !!source && EO_SOURCES.includes(source.toUpperCase());
